import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { ServicemanagerguardGuard } from 'src/app/core/authguards/servicemanager.guard';
import { ServicemanagerLayoutComponent } from 'src/app/core/layouts/servicemanager-layout/servicemanager-layout.component';
import { NormaluserLayoutComponent } from 'src/app/core/layouts/normaluser-layout/normaluser-layout.component';
import { RegisterBusinessComponent } from './register-business/register-business.component';
import { NormaluserguardGuard } from 'src/app/core/authguards/normaluser.guard';
import { CustomeruserguardGuard } from 'src/app/core/authguards/customeruser.guard';
import { BusinessuserguardGuard } from 'src/app/core/authguards/businessuser.guard';
import { BusinessuserLayoutComponent } from 'src/app/core/layouts/businessuser-layout/businessuser-layout.component';
import { BookingDetailComponent } from './booking-detail/booking-detail.component';
import { CategoryDetailComponent } from './category-detail/category-detail.component';
import { BookingOrdersComponent } from './booking-orders/booking-orders.component';
import { ConfirmEnquiryComponent } from './booking-detail/confirm-enquiry/confirm-enquiry.component';
import { RoleSetupPageComponent } from './role-setup/role-setup.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'landingpage',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component:LoginComponent
    
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
  path: 'category',
  component: CategoryDetailComponent
},

  { path: 'category/:id', component: CategoryDetailComponent },
  {
    path: 'register',
    component:RegisterComponent
  },
  { path: 'confirm-enquiry/:id', component: ConfirmEnquiryComponent },

  {
    path: 'register-business',
    component:RegisterBusinessComponent
  },
  { path: 'setup-role', component: RoleSetupPageComponent },
   { path: 'booking-detail/:id', component: BookingDetailComponent },
  {
    path: 'landingpage',
    component:LandingpageComponent
  },
  { path: 'privacypolicy', redirectTo: '/privacy', pathMatch: 'full' },
  { path: 'termsandcondition', redirectTo: '/terms', pathMatch: 'full' },

  {
    path: 'servicemanager',
    component: ServicemanagerLayoutComponent,
    // ...canActivate(redirectUnauthorizedToLogin),
    canActivateChild: [ServicemanagerguardGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('../../views/servicemanagerview/servicemanagerview.module').then(m => m.ServicemanagerviewModule),
    
      },
    ]
  },
  
   {
    path: 'customer',
    component: NormaluserLayoutComponent,
    // ...canActivate(redirectUnauthorizedToLogin),
    canActivateChild: [CustomeruserguardGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('../../views/customerview/customerview.module').then(m => m.CustomerViewModule),
    
      },
    ]
  },
  {
  path: 'business',
    component: BusinessuserLayoutComponent,

  // ...canActivate(redirectUnauthorizedToLogin),
    canActivateChild: [BusinessuserguardGuard],

  children: [
    {
      path: '',
      loadChildren: () =>
        import('../../views/businessview/businessview.module').then(
          (m) => m.BusinessViewModule
        ),
    },
  ],
}
  
]

@NgModule({
  imports: [RouterModule.forChild(routes)],

  exports: [RouterModule]
})
export class AuthRoutingModule { }